import { useState } from "react";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { WHATSAPP_URL } from "@/constants";
import { WhatsAppIcon } from "@/components/icons";

const linkClass = ({ isActive }) =>
  `text-sm font-medium tracking-wide transition-colors duration-200 hover:text-caramel ${
    isActive ? "text-caramel" : "text-chocolate"
  }`;

export const Header = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const goToDoces = (e) => {
    e.preventDefault();
    setOpen(false);
    const scroll = () =>
      document.getElementById("doces")?.scrollIntoView({ behavior: "smooth" });
    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(scroll, 120);
    } else {
      scroll();
    }
  };

  return (
    <header className="sticky top-0 z-40 bg-cream/90 backdrop-blur-md border-b border-sand">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 h-20 flex items-center justify-between">
        <Link to="/" aria-label="Doce Casa — página inicial" data-testid="header-logo" className="flex items-center shrink-0">
          <img
            src="/images/logo.png"
            alt="Logótipo da Doce Casa — casinha com bolo fumegante"
            className="h-14 w-auto"
          />
        </Link>

        <nav aria-label="Navegação principal" className="hidden md:flex items-center gap-8">
          <NavLink to="/" end className={linkClass} data-testid="nav-home-link">
            Início
          </NavLink>
          <a href="/#doces" onClick={goToDoces} className="text-sm font-medium tracking-wide text-chocolate transition-colors duration-200 hover:text-caramel" data-testid="nav-sweets-link">
            Os nossos doces
          </a>
          <NavLink to="/encomendar" className={linkClass} data-testid="nav-order-link">
            Encomendar
          </NavLink>
          <NavLink to="/historia" className={linkClass} data-testid="nav-story-link">
            A nossa história
          </NavLink>
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="nav-whatsapp-btn"
            className="inline-flex items-center gap-2 rounded-full bg-caramel px-5 py-2.5 text-sm font-medium text-cream shadow-sm transition-all duration-200 hover:bg-caramel-dark hover:shadow-md"
          >
            <WhatsAppIcon className="w-4 h-4" />
            Pedir pelo WhatsApp
          </a>
        </nav>

        <button
          type="button"
          onClick={() => setOpen(!open)}
          aria-expanded={open}
          aria-label={open ? "Fechar menu" : "Abrir menu"}
          data-testid="mobile-menu-toggle"
          className="md:hidden inline-flex items-center justify-center rounded-full p-2.5 text-chocolate transition-colors hover:bg-beige"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <nav aria-label="Menu móvel" className="md:hidden border-t border-sand bg-cream" data-testid="mobile-menu">
          <div className="px-6 py-4 flex flex-col gap-1">
            <NavLink to="/" end onClick={() => setOpen(false)} data-testid="mobile-nav-home-link" className="rounded-xl px-4 py-3 text-base font-medium text-chocolate hover:bg-beige">
              Início
            </NavLink>
            <a href="/#doces" onClick={goToDoces} data-testid="mobile-nav-sweets-link" className="rounded-xl px-4 py-3 text-base font-medium text-chocolate hover:bg-beige">
              Os nossos doces
            </a>
            <NavLink to="/encomendar" onClick={() => setOpen(false)} data-testid="mobile-nav-order-link" className="rounded-xl px-4 py-3 text-base font-medium text-chocolate hover:bg-beige">
              Encomendar
            </NavLink>
            <NavLink to="/historia" onClick={() => setOpen(false)} data-testid="mobile-nav-story-link" className="rounded-xl px-4 py-3 text-base font-medium text-chocolate hover:bg-beige">
              A nossa história
            </NavLink>
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="mobile-nav-whatsapp-btn"
              className="mt-2 inline-flex items-center justify-center gap-2 rounded-full bg-caramel px-5 py-3 text-base font-medium text-cream"
            >
              <WhatsAppIcon className="w-5 h-5" />
              Pedir pelo WhatsApp
            </a>
          </div>
        </nav>
      )}
    </header>
  );
};
